import React from 'react'

import flash from '/lib/flash'

import { Link, Prompt } from 'react-router-dom'
import classnames from 'classnames'

import { state_actions } from '/models/ticket'
import { state_actions as ci_state_actions } from '/models/cost-item'

import './styles'

# Components
import ProgressBar    from 'react-bootstrap/lib/ProgressBar'
import StateLabel     from '/components/state-label'
import UserCard       from '/components/user-card'
import List           from '/components/list'
import Price          from '/components/price'
import Datetime       from '/components/datetime'
import Spinner        from '/components/spinner'
import ReactSelect    from '/components/react-select'

import {
  withTicketCancel
  withCostItemCancel
  withEvent
  withRefunds
} from './queries'

export default \
withEvent \
withRefunds \
withCostItemCancel \
withTicketCancel \
class Refunds extends React.Component
  constructor: ->
    super arguments...
    @state = @defaultState()
    @active_row_ref = React.createRef()

  defaultState: ->
    is_playing: false
    is_fetching: false
    is_complete: false
    status_message: "-"
    num_to_complete: 0
    num_completed: 0
    amount_to_refund: 0
    amount_refunded: 0
    selected_rates: []
    active_row_id: null

  componentDidUpdate: (prevProps, prevState) ->
    if prevState.active_row_id isnt @state.active_row_id
      @active_row_ref?.current?.scrollIntoView
        behavior: 'smooth'
        block: 'start'

    if prevState.is_playing isnt @state.is_playing
      if @state.is_playing
        window.addEventListener "beforeunload", @handleBeforeUnload
      else
        window.removeEventListener "beforeunload", @handleBeforeUnload

  componentWillUnmount: ->
    window.removeEventListener "beforeunload", @handleBeforeUnload

  setStateAsync: (new_state) =>
    new Promise (resolve) =>
      @setState new_state, resolve

  handleBeforeUnload: (evt) ->
    evt.preventDefault()
    evt.returnValue = ""

  costItemCancel: (id)=>
    @setState is_fetching: true
    {cost_item, errors} = await @props.costItemCancel id
    @setState is_fetching: false

    flash.error(errors) if errors?.length
    not errors?.length

  ticketCancel: (id)=>
    @setState is_fetching: true
    {ticket, errors} = await @props.ticketCancel id
    @setState is_fetching: false

    flash.error(errors) if errors?.length
    not errors?.length

  processCancellations: =>
    for t in @cancellableTickets()
      @setState active_row_id: t.id

      if @fullyCancellable t
        return unless @state.is_playing

        @setState status_message: "Refunding ticket: #{t.id}"

        if await @ticketCancel t.id
          @setState (prev_state) ->
            status_message: "Refunded ticket: #{t.id}"
            amount_refunded: prev_state.amount_refunded + t.price
            num_completed: prev_state.num_completed + t.cost_items.length

      else if @partiallyCancellable t
        for ci in t.cost_items when @costItemCancellable ci
          return unless @state.is_playing

          @setState status_message: "Refunding cost item: #{ci.id}"

          if await @costItemCancel ci.id
            @setState (prev_state)->
              status_message: "Refunded cost item: #{ci.id}"
              amount_refunded: prev_state.amount_refunded + ci.src_price
              num_completed: prev_state.num_completed + 1

    @setState
      is_complete: true
      status_message: "Complete!"
      active_row_id: null
    @togglePlay()

  totalRefundableAmount: =>
    @cancellableTickets().reduce ((sum, ticket) =>
      for ci in ticket.cost_items.filter((ci) => @costItemCancellable(ci))
        sum += ci.src_price or 0
      sum
    ), 0

  numCancellableCostItems: ->
    @props.tickets.reduce (sum, ticket) =>
      sum + ticket.cost_items.filter((ci) => @costItemCancellable(ci)).length
    , 0

  cancellableTickets: =>
    @props.tickets
      .filter (t)=>
        @fullyCancellable(t) or @partiallyCancellable(t)

  fullyCancellable: (t)=>
    t.cost_items
      .every (ci)=>
        @costItemCancellable ci

  partiallyCancellable: (t)=>
    not @fullyCancellable(t) and
      t.cost_items
        .some (ci) =>
          @costItemCancellable(ci)

  costItemCancellable: (ci)=>
    ci.voidable and
      @state.selected_rates.some (opt) -> opt.value is ci.rate_id

  statsForRate: (cost_items) =>
    for rate in @props.rates
      rate: rate
      paid: ci for ci in cost_items when ci.rate_id is rate.id and ci.voidable
      cancelled: ci for ci in cost_items when ci.rate_id is rate.id and ci.state is 'cancelled'

  rateNameForTicket: (ticket)=>
    (@props.rates.find (r)-> r.id is ticket.rate_id)?.name

  render: ->
    return <Spinner/> if @props.refundsLoading

    <div className="Refunds">
      <Prompt
        when={@state.is_playing}
        message="Are you sure you want to leave this page?"
      />
      <div className="refunds-container">
        {@rateSelection()}
        {@refundControl()}
      </div>
      {@tickets()}
    </div>

  refundControl: =>
    currency = @props.event?.tickets?[0].src_currency or "USD"

    <div className="control">
      <div className="stats">
        <div>
          <h2 className="key">Cost items cancelled</h2>
          <span className="value">
            {"#{@state.num_completed} / #{@state.num_to_complete}"}
          </span>
        </div>
        <div>
          <h2 className="key">Refunded</h2>
          <span className="value">
            <Price
              amount={@state.amount_refunded}
              currency={currency}
              showCurrency={false}
              showFree={false}
            /> /
            <Price
              amount={@state.amount_to_refund}
              currency={currency}
              showCurrency={false}
              showFree={false}
            />
          </span>
        </div>
      </div>
      <div>
        <div className="status">
          <span>{@state.status_message}</span>
        </div>
        {@progressBar()}
      </div>
    </div>

  progressBar: =>
    { num_to_complete, num_completed, is_playing, is_fetching } = @state
    is_paused = is_fetching and not is_playing

    bs_style =
      if is_paused then "warning"
      else if is_fetching then "info"
      else "success"

    try
      percent = 100 * (num_completed / num_to_complete) or 0

    <ProgressBar className="progress">
      <ProgressBar active={is_playing} bsStyle={bs_style} now={percent} key={1} />
    </ProgressBar>

  rateSelection: =>
    <div className="selection">
      {@rates()}
      {@selectionButton()}
    </div>

  selectRate: (opt)=>
    await @setStateAsync
      selected_rates: opt

    @setState
      amount_to_refund: @totalRefundableAmount()
      num_to_complete: @numCancellableCostItems()

  rates: =>
    rate_options = for r in @props.rates
      { value: r.id, label: r.name }

    <div className="rates">
      <ReactSelect
        className="filter-selector state-selector"
        options={rate_options}
        value={@state.selected_rates}
        onChange={@selectRate}
        placeholder="Rates to cancel"
        autosize={false}
        disabled={@state.is_complete}
        multi
      />
    </div>

  togglePlay: =>
    await @setStateAsync (prevState) ->
      is_playing: not prevState.is_playing

    if @state.is_playing
      @processCancellations()

  selectionButton: =>
    { is_complete, num_to_complete, num_completed, is_playing, is_fetching } = @state
    is_disabled = num_to_complete is num_completed and not is_complete
    is_pausing = is_fetching and not is_playing

    label =
      if is_pausing then "⏸ Pausing..."
      else if is_complete then "⏹ Reset"
      else if is_playing then "⏸ Pause"
      else "▶ Start"

    on_click =
      if is_complete then => @setState @defaultState()
      else @togglePlay

    <button
      disabled={is_disabled}
      className="btn btn-sm btn-default"
      onClick={on_click}
    >
      {label}
    </button>

  ticketLabel: (ticket)=>
    return <span className="label">Fully cancellable</span> if @fullyCancellable ticket
    return <span className="label">Partially cancellable</span> if @partiallyCancellable ticket
    null

  tickets: =>
    { rates, tickets } = @props

    return null unless tickets.length
    <div className="tickets">
      <h2>Tickets</h2>
      <List>
        {for t in @props.tickets
          is_active = t.id is @state.active_row_id

          ref = if is_active then @active_row_ref else null
          active_classname = classnames({ active: is_active })

          <List.Row key={t.id} className={active_classname}>
            <div className="stack" ref={ref}>
              <List.Cell className="id">
                <Link className="btn btn-default" to={"/tickets/#{t.id}"}>
                  More info
                </Link>
              </List.Cell>
              <List.Cell className="user">
                <UserCard user={t.user} />
              </List.Cell>
              <List.Cell className="rate">
                {@rateNameForTicket t}
              </List.Cell>
              <List.Cell className="price">
                <Price amount={t.price} currency={t.src_currency}/>
              </List.Cell>
              <List.Cell className="created-at">
                <Datetime date={t.created_at}/>
              </List.Cell>
              <List.Cell className="cancellable">
                {@ticketLabel t}
              </List.Cell>
              <List.Cell className="state-label">
                <StateLabel
                  model={t}
                />
              </List.Cell>
            </div>
            <div className="stack">
              {@groupedRates t.cost_items}
            </div>
          </List.Row>
        }
      </List>
    </div>

  groupedRates: (cost_items)=>
    <div className="grouped-rates">
      {for {rate, paid, cancelled} in @statsForRate cost_items
        num_paid = paid.length
        num_cancelled = cancelled.length

        if num_paid or num_cancelled
          <div key={rate.id} className="rates-row">
            <span className="rates-name">{rate.name}</span>
            <span className="rates-cell paid">
              <b>x{num_paid}</b> Paid
            </span>
            <span className="rates-cell cancelled">
              <b>x{num_cancelled}</b> Cancelled
            </span>
          </div>
      }
    </div>
